module.exports = __webpack_public_path__ + "static/img/preview-02.f0ed7e58.webp";